/**
 * Transforms a VTEX image URL to use a specific size format.
 * This will make the image be processed and reduced to the specified size.
 * Handles URLs with or without existing size parameters, ensuring the final URL uses the provided size.
 *
 * @param imageUrl - The original VTEX image URL (e.g., https://account.vteximg.com.br/arquivos/ids/158580/image.png?v=... or https://account.vteximg.com.br/arquivos/ids/162024-1000-1000/image.jpg)
 * @param size - Optional size value (default: 128). The format will be {size}-{size}
 * @returns The transformed URL with -{size}-{size} appended to the image ID, or the original URL if it's not a valid VTEX image URL
 */
export const transformImageURL = (imageUrl?: string, size: number = 128) => {
  try {
    if (
      !imageUrl ||
      typeof imageUrl !== 'string' ||
      !imageUrl.includes('.vteximg.com')
    ) {
      throw new Error('Invalid image URL')
    }

    const transformedUrl = imageUrl.replace(
      /\/ids\/(\d+)(?:-\d+-\d+)?\//,
      `/ids/$1-${size}-${size}/`
    )

    return transformedUrl
  } catch {
    return imageUrl
  }
}
